import React, { useEffect, useState } from "react";
import CTA from "./CTA";
import "./header.css";
import userProfile from "../../assets/kushtrimshabani-image-bg.webp";
import HeaderSocials from "./HeaderSocials";

const useTypingEffect = (text, speed = 80, delay = 600) => {
  const [displayed, setDisplayed] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    let i = 0;
    const timer = setTimeout(() => {
      const interval = setInterval(() => {
        setDisplayed(text.slice(0, ++i));
        if (i >= text.length) {
          clearInterval(interval);
          setDone(true);
        }
      }, speed);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timer);
  }, [text, speed, delay]);

  return { displayed, done };
};

const Header = () => {
  const yearsExperience = new Date().getFullYear() - 2021;
  const { displayed: typedName, done: typingDone } = useTypingEffect(
    "Kushtrim",
    100,
    400
  );

  return (
    <header id="home" role="banner" className="hero">
      <div className="container hero__container">
        <div className="hero__copy">
          <p className="hero__tag pixel-text">&#9670; full-stack dev</p>

          <h1 className="hero__headline">
            Hey, I&apos;m{" "}
            <span className="gradient-text">
              {typedName}
              <span
                className={`hero__cursor${
                  typingDone ? " hero__cursor--blink" : ""
                }`}
              >
                _
              </span>
            </span>
          </h1>

          <p className="hero__summary">
            I&apos;ve been building web apps for {yearsExperience}+ years -
            mostly with React, Next.js, NestJS, and Python. Currently
            working on production platforms at DCoding Labs. Based in
            Kosovo.
          </p>

          <div className="hero__meta">
            <div className="hero__meta-item">
              <span className="hero__meta-value">{yearsExperience}+ years</span>
              <span className="hero__meta-label">Experience</span>
            </div>
            <div className="hero__meta-item">
              <span className="hero__meta-value">20+ projects</span>
              <span className="hero__meta-label">Shipped</span>
            </div>
            <div className="hero__meta-item">
              <span className="hero__meta-value">Kosovo</span>
              <span className="hero__meta-label">Based</span>
            </div>
          </div>

          <CTA />
          <HeaderSocials />
        </div>

        <div className="hero__visual">
          <div className="hero__portrait glow-border">
            <div className="hero__portrait-glow" aria-hidden="true" />
            <img
              className="hero__portrait-image"
              src={userProfile}
              alt="Kushtrim Shabani"
              width="700"
              height="710"
              loading="eager"
              fetchpriority="high"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
